import React from "react";

import Header from "../components/header";
import Sections from "../components/sections";
import About from "../components/about";
import Slideshow from "../components/slideshow";
import DividerBottom from "../components/divider-bottom"; 
import Footer from "../components/footer";

function Home() {
  return (
    <>
      <Header />

      <main id="home">
        <Sections />
        <section id="homepage-about-group-container">
          <About />
        </section>
        <section id="homepage-slideshow-group-container">
          <Slideshow />
        </section>
        <DividerBottom />
      </main>

      <Footer />
    </>
  );
}

export default Home;